#import "../flexibleSections/flexibleSections.graphql"
#import "~/graphql/fragments/socialFragment.graphql"
#import "~/graphql/fragments/assets/defaultImageAsset.graphql"

fragment defaultPageContent on page_Entry {
    title
    parent {
        title
        uri
    }
    image {
        ... DefaultImageAsset
    }
    video: videoUrl
    showNewsletterSubscribe
    flexibleSections {
        ... flexibleSections
    }
    seo {
        ... socialFragment
    }
}
